import * as api from '../../api';
import * as tagBinderActions from './actions';
import { message } from '@myua/kit';
import { getAssetsFilter, getPermissions } from '../app/selectors';
import { takeLatest, takeOnce } from '../../listenerMiddleware';
import * as appActions from '../app/actions';
import { Permission } from '../../../general/model';

export const tagBinderListeners = () => {
  init();
  watchSubmitted();
};

function init() {
  takeOnce(appActions.initialized, async (action, { getState, dispatch }) => {
    const permissions = getPermissions(getState());
    if (permissions[Permission['fs.assetlab_set_tag_to_asset']]) {
      const result = await api.loadTags({ showAll: true });
      if (result.success) {
        dispatch(tagBinderActions.tagsLoaded({ tags: result.data.response }));
      }
    }
  });
}

function watchSubmitted() {
  takeLatest(tagBinderActions.submitted, async ({ payload }, { getState, dispatch, signal }) => {
    const { tagIds, assetIds, selectAll } = payload;

    dispatch(tagBinderActions.setInProgress({ inProgress: true }));
    const filter = getAssetsFilter(getState());
    const result = await api.bindTags({
      tag_ids: tagIds,
      asset_ids: selectAll ? undefined : assetIds,
      filter: selectAll ? filter : undefined,
    });
    if (signal.aborted) {
      return;
    }
    dispatch(tagBinderActions.setInProgress({ inProgress: false }));

    if (result.success) {
      dispatch(tagBinderActions.setVisible({ visible: false }));
      dispatch(tagBinderActions.completed());
      void message.success('Tags have been added');
    } else {
      void message.error('Tags have not been added');
    }
  });
}
